var initialState = {
    itemCondition: null,
    validationError: null,
    selectionError: null,
    isDirty: false,
};

function validate(newState) {
    return {
        ...newState,
        validationError:
            newState.itemCondition == null ||
            newState.itemCondition.trim() == '' ||
            newState.itemCondition === 'Undefined'
                ? 'syi_validation_missing_condition'
                : newState.selectionError,
    };
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ITEM_CONDITION_FROM_USER':
            return validate({
                ...state,
                isDirty: action.payload !== initialState.itemCondition,
                itemCondition: action.payload,
            });
        case 'SET_ITEM_CONDITION':
            return validate({ ...state, itemCondition: action.payload });
        case 'RESET_ITEM_CONDITION':
            return validate({ ...initialState });
        case 'SET_ITEM_CONDITION_SELECTION_ERROR':
            return validate({ ...state, selectionError: action.payload });
        default:
            return state;
    }
};
